const gendersJobPosition = [
  { name: "Female", value: "FEMALE" },
  { name: "Male", value: "MALE" },
  { name: "No preference", value: "NO_PREFERENCE" },
];

export default gendersJobPosition;
